import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_licenseplate_total_packaged_amount_widgetService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async get($inParams: { licensePlateId: number }): Promise<{ result?: { PackagedAmount?: number } }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.licensePlateId)) {
      $missingRequiredInParams.push('\'licensePlateId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      licensePlateId: number    }) {
        if(isNil($inParams.licensePlateId)) {
          return true; 
        }
      return false;
    }
}
